import { FC } from "react";

import { FontSizes, MessageBar, Stack } from "@bps/fluent-ui";
import { useContactsWithDuplicatedMobile } from "@modules/practice/screens/address-book/components/hooks/useContactsWithDuplicatedMobile.tsx";
import { CommunicationFieldValue } from "@shared-types/practice/communication-field-value.type.ts";
import { Contact } from "@stores/practice/models/Contact.ts";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";

import { ContactsWithDuplicatedMobile } from "./ContactsWithDuplicatedMobile.tsx";

interface DuplicatedMobileMessageBarProps {
  value: CommunicationFieldValue | undefined;
  contact: Contact | undefined;
}
export const DuplicatedMobileMessageBar: FC<
  DuplicatedMobileMessageBarProps
> = ({ value, contact }) => {
  const {
    duplicatesExist,
    duplicatedPatients,
    duplicatedIndividuals,
    duplicatedOrganisations
  } = useContactsWithDuplicatedMobile({
    originalContactId: contact?.id,
    type: value?.type,
    value: value?.value
  });

  const patientLabel = usePatientLabel(true);

  if (!duplicatesExist) return null;

  return (
    <MessageBar
      styles={({ theme }) => ({
        root: {
          backgroundColor: theme.palette.themeLighter,
          fontSize: FontSizes.small
        }
      })}
    >
      <Stack>
        Contacts with the same mobile number:
        <ContactsWithDuplicatedMobile
          title={`${patientLabel}s`}
          contacts={duplicatedPatients}
        />
        <ContactsWithDuplicatedMobile
          title="Individuals"
          contacts={duplicatedIndividuals}
        />
        <ContactsWithDuplicatedMobile
          title="Organisations"
          contacts={duplicatedOrganisations}
        />
      </Stack>
    </MessageBar>
  );
};
